import { Component, computed, inject, input, Input, InputSignal, Signal, PLATFORM_ID, OnInit } from '@angular/core';
import { IItemDetails } from '../../models/IItemDetails';
import { faUpRightAndDownLeftFromCenter, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GalleriaModule } from 'primeng/galleria';
import { GalleryImage } from './gallery-image';
import { AbsoluteMediaUriService } from '../../services/absolute-media-uri.service';
import { isPlatformBrowser } from '@angular/common';
import { ThemeService } from '../../services/theme.service';
import { DefaultImageComponent } from "../auctions/default-image/default-image.component";


@Component({
  selector: 'app-gallery-full-image',
  imports: [FontAwesomeModule, GalleriaModule, DefaultImageComponent],
  templateUrl: './gallery-full-image.component.html',
  styleUrl: './gallery-full-image.component.scss'
})
export class GalleryFullImageComponent implements OnInit {

  @Input() isCommunity: boolean = false;

  private readonly platformId = inject(PLATFORM_ID);
    private readonly themeService = inject(ThemeService);
  

  private absoluteMediaUriService = inject(AbsoluteMediaUriService);

  faUpRightAndDownLeftFromCenter = faUpRightAndDownLeftFromCenter;
  faXmark = faXmark;

  responsiveOptions: any[] = [
    {
      breakpoint: '1300px',
      numVisible: 4
    },
    {
      breakpoint: '575px',
      numVisible: 4
    }
  ];

  ngOnInit(): void {
        // this.themeService.customizeAuctionTheme(this.id);

  }

  displayBasic: boolean = false;

  gallery: InputSignal<string[]> = input(['']);
  @Input() itemModal?: IItemDetails | null = null;
  @Input() showLotNumber: boolean = false;

  protected galleryImages: Signal<GalleryImage[]> = computed(() => {
    const gallery = this.gallery();
    const item = this.itemModal;
    if (gallery == null || gallery == undefined || item == null || item == undefined) {
      return [];
    }
    let x = gallery.map(image => {
      return {
        previewUrl: image,
        originalUrl: this.getOriginalSizeImageUrl(image, item)
      }
    })
    return x;
  });

  private getOriginalSizeImageUrl(image: string, item: IItemDetails) {
    if (item != null && item != undefined) {
      const originalSizedImagesUrls = item.originalSizedImagesUrls;
      const imageId = this.getImageId(image);
      if (imageId != null) {
        const originalSizedImage = originalSizedImagesUrls.find(i => i.imageId == imageId);
        if (originalSizedImage != undefined) {
          const originalSizedImageUrl = this.absoluteMediaUriService.getAbsoluteMediaUri(originalSizedImage.url);
          return  originalSizedImageUrl;
        }
      }
    }
    return image;
  }

  private getImageId(image: string) {
    const matches = /\/orgs\/[a-zA-Z0-9]+\/[0-9]+\/([0-9]+)\./.exec(image);
    if (matches != null && matches.length > 1 && matches[1] != undefined) {
      return Number(matches[1]);
    }
    return null;
  }
}
